export interface BuildNumber {
    productVersion: string;
    buildVersion: number;
    commitHash: string;
    fullVersion: string;
    assemblyVersion: string;
}